import { Text, View } from "@react-pdf/renderer";

import { replaceUnderscoresUpperCase } from "~/common/utils";
import { MentalStatusExaminationReport } from "~/providers/utils/types/consultation/patientConsultationReportTypes";

export const ConsultationExportReportExams = ({
  exam,
}: {
  exam: MentalStatusExaminationReport;
}) => {
  return (
    <View
      style={{
        flexDirection: "row",
        flexWrap: "wrap",
        marginLeft: -4,
        marginRight: -4,
      }}
    >
      {Object.entries(exam).map(([key, value]: [string, string]) => (
        <View
          key={key}
          style={{
            width: "50%",
            padding: 4,
            flexDirection: "column",
          }}
          wrap={false}
        >
          <View
            style={{
              backgroundColor: "#F0F4FE",
              flexGrow: 1,
              borderRadius: 6,
              paddingHorizontal: 12,
              paddingVertical: 8,
            }}
          >
            <Text style={{ fontWeight: 600, marginBottom: 4 }}>
              {replaceUnderscoresUpperCase(key)}
            </Text>
            <Text style={{ color: "#4C5560" }}>{value}</Text>
          </View>
        </View>
      ))}
    </View>
  );
};
